/* ============================================================
   India Coverage Map — assets/india-coverage-map.js

   KEY FIX: Google Maps regular URLs are blocked in iframes
   (X-Frame-Options: sameorigin). We auto-generate the correct
   embeddable URL from lat/lng:
   https://maps.google.com/maps?q=LAT,LNG&output=embed&z=15
   This works without any API key.
   ============================================================ */

   (function () {
    'use strict';
  
    /* ── Pin colours ────────────────────────────────────────── */
    var COLORS = {
      india:         '#0e7377',
      factory:       '#e07b2a',
      international: '#6b4fa0'
    };
  
    /* ── State ──────────────────────────────────────────────── */
    var leafMap     = null;
    var markers     = {};   /* id → Leaflet marker */
    var locations   = [];   /* parsed location objects */
    var activeTab   = 'all';
    var activeQuery = '';
  
    /* ── Wait for both DOM + Leaflet ────────────────────────── */
    function ready(fn) {
      if (document.readyState !== 'loading') { fn(); }
      else { document.addEventListener('DOMContentLoaded', fn); }
    }
  
    ready(function () {
      /* Leaflet loads via CDN — poll until available */
      if (typeof L === 'undefined') {
        var attempts = 0;
        var poll = setInterval(function () {
          attempts++;
          if (typeof L !== 'undefined') { clearInterval(poll); boot(); }
          if (attempts > 40) { clearInterval(poll); console.error('Leaflet failed to load'); }
        }, 100);
      } else {
        boot();
      }
    });
  
    /* ── Boot ───────────────────────────────────────────────── */
    function boot() {
      locations = parseLocations();
      if (!locations.length) {
        console.warn('ICM: No location blocks found. Add location blocks in Theme Editor.');
      }
  
      initMap();
      addAllMarkers();
      fitVisible();
  
      bindSearch();
      bindTabs();
      bindCardActions();
      bindReset();
      bindModal();
      updateCount();
    }
  
    /* ── Parse location data divs ───────────────────────────── */
    function parseLocations() {
      var out = [];
      var wrap = document.getElementById('icm-location-data');
      if (!wrap) return out;
  
      var divs = wrap.querySelectorAll('[data-lat]');
      divs.forEach(function (d) {
        var lat = parseFloat(d.dataset.lat);
        var lng = parseFloat(d.dataset.lng);
        if (isNaN(lat) || isNaN(lng)) return;
        out.push({
          id  : d.dataset.id   || '',
          name: d.dataset.name || '',
          city: d.dataset.city || '',
          addr: d.dataset.addr || '',
          dir : d.dataset.dir  || '',
          type: d.dataset.type || 'india',
          lat : lat,
          lng : lng
        });
      });
      return out;
    }
  
    /* ── Build Google Maps EMBEDDABLE URL from coordinates ───── */
    /* This is the KEY FIX — regular google.com/maps URLs are
       blocked. maps.google.com/maps?q=LAT,LNG&output=embed works */
    function buildEmbedUrl(lat, lng, name) {
      var q = encodeURIComponent(name || (lat + ',' + lng));
      return 'https://maps.google.com/maps?q=' + lat + ',' + lng
        + '&output=embed&z=16&hl=en';
    }
  
    /* ── Init Leaflet map ───────────────────────────────────── */
    function initMap() {
      var el = document.getElementById('icm-leaflet-map');
      if (!el) return;
  
      leafMap = L.map('icm-leaflet-map', {
        center          : [22.5, 82.0],
        zoom            : 5,
        scrollWheelZoom : false,
        zoomControl     : true
      });
  
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution : '© <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
        maxZoom     : 18
      }).addTo(leafMap);
    }
  
    /* ── Build custom SVG pin ───────────────────────────────── */
    function makeIcon(type, enlarged) {
      var color = COLORS[type] || COLORS.india;
      var scale = enlarged ? 1.35 : 1;
      var w = Math.round(28 * scale);
      var h = Math.round(38 * scale);
      var uid = type + (enlarged ? '_big' : '_sm');
  
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '" viewBox="0 0 28 38">'
        + '<defs><filter id="f' + uid + '" x="-30%" y="-20%" width="160%" height="160%">'
        + '<feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.30)"/>'
        + '</filter></defs>'
        + '<path filter="url(#f' + uid + ')" fill="' + color + '" d="M14 1C8.48 1 4 5.48 4 11c0 8.25 10 25 10 25S24 19.25 24 11C24 5.48 19.52 1 14 1z"/>'
        + '<circle cx="14" cy="11" r="4.5" fill="white" opacity="0.92"/>'
        + '</svg>';
  
      return L.divIcon({
        className  : '',
        html       : svg,
        iconSize   : [w, h],
        iconAnchor : [w / 2, h],
        popupAnchor: [0, -(h + 6)]
      });
    }
  
    /* ── Add all markers ────────────────────────────────────── */
    function addAllMarkers() {
      if (!leafMap) return;
  
      locations.forEach(function (loc) {
        var m = L.marker([loc.lat, loc.lng], { icon: makeIcon(loc.type, false) });
        m.addTo(leafMap);
  
        /* Build popup HTML */
        var typeLabel = { india: 'Office', factory: 'Factory', international: 'International' }[loc.type] || 'Office';
        var html = '<div class="icm-popup">'
          + '<span class="icm-popup-badge icm-popup-badge--' + loc.type + '">' + typeLabel + '</span>'
          + '<div class="icm-popup-name">' + esc(loc.name) + '</div>'
          + (loc.city ? '<div class="icm-popup-city">' + esc(loc.city) + '</div>' : '')
          + (loc.addr ? '<div class="icm-popup-addr">' + esc(loc.addr) + '</div>' : '')
          + '<div class="icm-popup-btns">'
          + '<button class="icm-btn icm-btn--primary icm-pp-view" type="button"'
          +   ' data-id="'   + esc(loc.id)   + '"'
          +   ' data-name="' + esc(loc.name) + '"'
          +   ' data-addr="' + esc(loc.addr) + '"'
          +   ' data-lat="'  + loc.lat       + '"'
          +   ' data-lng="'  + loc.lng       + '"'
          +   ' data-dir="'  + esc(loc.dir)  + '">'
          +   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" style="width:12px;height:12px"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>'
          +   'View Map'
          + '</button>';
        if (loc.dir) {
          html += '<a class="icm-btn icm-btn--outline" href="' + esc(loc.dir) + '" target="_blank" rel="noopener noreferrer">'
            + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" style="width:12px;height:12px"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>'
            + 'Directions</a>';
        }
        html += '</div></div>';
  
        m.bindPopup(html, { maxWidth: 270, minWidth: 220 });
  
        /* When popup opens, wire "View Map" button inside it */
        m.on('popupopen', function () {
          var btn = document.querySelector('.icm-pp-view[data-id="' + loc.id + '"]');
          if (btn) {
            btn.onclick = function () {
              openModal(btn.dataset.name, btn.dataset.addr, btn.dataset.lat, btn.dataset.lng, btn.dataset.dir);
            };
          }
          highlightCard(loc.id, false); /* highlight but don't scroll */
        });
  
        markers[loc.id] = m;
      });
    }
  
    /* ── Fit map bounds to visible markers ───────────────────── */
    function fitVisible() {
      if (!leafMap) return;
      var vis = getVisible();
      if (!vis.length) return;
      if (vis.length === 1) {
        leafMap.setView([vis[0].lat, vis[0].lng], 13);
        return;
      }
      leafMap.fitBounds(
        vis.map(function (l) { return [l.lat, l.lng]; }),
        { padding: [40, 40], maxZoom: 13, animate: true }
      );
    }
  
    /* ── Get currently visible locations ─────────────────────── */
    function getVisible() {
      return locations.filter(function (l) {
        return tabMatch(l) && queryMatch(l);
      });
    }
  
    function tabMatch(l) {
      if (activeTab === 'all')           return true;
      if (activeTab === 'india')         return l.type === 'india';
      if (activeTab === 'factory')       return l.type === 'factory';
      if (activeTab === 'international') return l.type === 'international';
      return true;
    }
  
    function queryMatch(l) {
      if (!activeQuery) return true;
      var hay = (l.name + ' ' + l.city + ' ' + l.addr + ' ' + l.type).toLowerCase();
      return hay.indexOf(activeQuery) !== -1;
    }
  
    /* ── Apply filter: cards + markers ──────────────────────── */
    function applyFilter() {
      var cards     = document.querySelectorAll('.icm-location-card');
      var noResults = document.getElementById('icm-no-results');
      var visCount  = 0;
  
      cards.forEach(function (card) {
        var loc  = findById(card.dataset.id);
        var show = loc && tabMatch(loc) && queryMatch(loc);
        card.style.display = show ? '' : 'none';
        if (show) visCount++;
  
        /* dim/show marker */
        var m = loc && markers[loc.id];
        if (m) {
          m.setOpacity(show ? 1 : 0.10);
          if (!show) m.closePopup();
        }
      });
  
      noResults && (noResults.style.display = visCount === 0 ? 'block' : 'none');
  
      fitVisible();
  
      /* Auto open popup if exactly 1 match */
      var vis = getVisible();
      if (vis.length === 1 && markers[vis[0].id]) {
        setTimeout(function () { markers[vis[0].id].openPopup(); }, 500);
      }
  
      updateCount();
      scrollListToTop();
    }
  
    /* ── Search ─────────────────────────────────────────────── */
    function bindSearch() {
      var input    = document.getElementById('icm-search');
      var clearBtn = document.getElementById('icm-search-clear');
      if (!input) return;
  
      input.addEventListener('input', debounce(function () {
        activeQuery = input.value.trim().toLowerCase();
        clearBtn && (clearBtn.style.display = activeQuery ? '' : 'none');
        applyFilter();
      }, 220));
  
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          activeQuery = '';
          clearBtn.style.display = 'none';
          applyFilter();
          input.focus();
        });
      }
    }
  
    /* ── Tab filter ─────────────────────────────────────────── */
    function bindTabs() {
      document.querySelectorAll('.icm-tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          document.querySelectorAll('.icm-tab').forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');
          activeTab = tab.dataset.filter;
          applyFilter();
        });
      });
    }
  
    /* ── Card actions: click row, Show on Map, View Map ──────── */
    function bindCardActions() {
      document.querySelectorAll('.icm-location-card').forEach(function (card) {
  
        /* Clicking the card body → fly to marker */
        card.addEventListener('click', function (e) {
          if (e.target.closest('button, a')) return;
          flyTo(card.dataset.id);
        });
  
        /* "Show on Map" button */
        var flyBtn = card.querySelector('.icm-fly-btn');
        if (flyBtn) {
          flyBtn.addEventListener('click', function () {
            flyTo(card.dataset.id);
          });
        }
  
        /* "View Map" button → open iframe modal */
        var viewBtn = card.querySelector('.icm-view-btn');
        if (viewBtn) {
          viewBtn.addEventListener('click', function () {
            openModal(
              card.dataset.name,
              card.dataset.addr,
              card.dataset.lat,
              card.dataset.lng,
              card.dataset.dir
            );
          });
        }
      });
    }
  
    /* ── Fly map to a location + open popup ─────────────────── */
function flyTo(id) {
    var loc = findById(id);
    if (!loc || !leafMap) return;
  
    highlightCard(id, true);
  
    /* ── MOBILE: scroll page up to map first ─────────────────
       On small screens the map is above the list. When user taps
       "Show on Map" from the list below, scroll the map into view
       before flying to the marker so they can actually see it.
    ──────────────────────────────────────────────────────────── */
    var mapEl = document.getElementById('icm-leaflet-map');
    if (mapEl && window.innerWidth < 960) {
      mapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      /* Give scroll time to complete before flying */
      setTimeout(function () { doFly(id, loc); }, 600);
    } else {
      doFly(id, loc);
    }
  }
  
  function doFly(id, loc) {
    /* Enlarge this pin, reset others */
    Object.keys(markers).forEach(function (mid) {
      var l = findById(mid);
      if (l) markers[mid].setIcon(makeIcon(l.type, mid === id));
    });
  
    leafMap.flyTo([loc.lat, loc.lng], 14, { duration: 1.2, easeLinearity: 0.5 });
  
    setTimeout(function () {
      if (markers[id]) markers[id].openPopup();
      /* Invalidate map size — fixes Leaflet grey-tile bug after scroll */
      leafMap.invalidateSize();
    }, 1000);
  }
  
    /* ── Highlight card ─────────────────────────────────────── */
    function highlightCard(id, scroll) {
      document.querySelectorAll('.icm-location-card').forEach(function (c) {
        var active = c.dataset.id === id;
        c.classList.toggle('is-active', active);
        if (active && scroll) {
          c.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }
  
    /* ── Reset ──────────────────────────────────────────────── */
    function bindReset() {
      var btn = document.getElementById('icm-reset');
      if (!btn) return;
      btn.addEventListener('click', function () {
        /* clear search */
        var input    = document.getElementById('icm-search');
        var clearBtn = document.getElementById('icm-search-clear');
        if (input) input.value = '';
        if (clearBtn) clearBtn.style.display = 'none';
        activeQuery = '';
  
        /* reset tab */
        activeTab = 'all';
        document.querySelectorAll('.icm-tab').forEach(function (t) {
          t.classList.toggle('is-active', t.dataset.filter === 'all');
        });
  
        /* reset cards */
        document.querySelectorAll('.icm-location-card').forEach(function (c) { c.classList.remove('is-active'); });
  
        /* reset markers */
        Object.keys(markers).forEach(function (id) {
          var l = findById(id);
          if (l) markers[id].setIcon(makeIcon(l.type, false));
          markers[id].setOpacity(1);
          markers[id].closePopup();
        });
  
        applyFilter();
      });
    }
  
    /* ── Count badge ────────────────────────────────────────── */
    function updateCount() {
      var el = document.getElementById('icm-count');
      if (el) el.textContent = getVisible().length + ' / ' + locations.length;
    }
  
    /* ── Modal (iframe) ──────────────────────────────────────── */
    function bindModal() {
      var overlay  = document.getElementById('icm-overlay');
      var closeBtn = document.getElementById('icm-close');
      if (!overlay) return;
  
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal();
      });
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    }
  
    function openModal(name, addr, lat, lng, dirUrl) {
      var overlay = document.getElementById('icm-overlay');
      var nameEl  = document.getElementById('icm-modal-name');
      var frame   = document.getElementById('icm-frame');
      var loading = document.getElementById('icm-loading');
      var dirLink = document.getElementById('icm-dir-link');
      var addrEl  = document.getElementById('icm-modal-addr');
      if (!overlay || !frame) return;
  
      /* Set title & address */
      if (nameEl) nameEl.textContent = name || 'Office Location';
      if (addrEl) addrEl.textContent = addr || '';
  
      /* Directions link */
      if (dirLink) {
        if (dirUrl) {
          dirLink.href = dirUrl;
          dirLink.style.display = '';
        } else {
          /* Fallback: generate Google Maps directions link from coords */
          dirLink.href = 'https://www.google.com/maps/dir/?api=1&destination=' + lat + ',' + lng;
          dirLink.style.display = '';
        }
      }
  
      /* Show loading, reset frame */
      if (loading) loading.style.display = 'flex';
      frame.src = 'about:blank';
  
      /* Open overlay */
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
  
      /* Load embed URL — built from lat/lng, no API key needed */
      var embedUrl = buildEmbedUrl(parseFloat(lat), parseFloat(lng), name);
      setTimeout(function () {
        frame.src = embedUrl;
        frame.onload = function () {
          if (loading) loading.style.display = 'none';
        };
        /* Safety timeout in case onload doesn't fire */
        setTimeout(function () {
          if (loading) loading.style.display = 'none';
        }, 5000);
      }, 150);
    }
  
    function closeModal() {
      var overlay = document.getElementById('icm-overlay');
      var frame   = document.getElementById('icm-frame');
      if (!overlay) return;
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      setTimeout(function () {
        if (frame) frame.src = 'about:blank';
      }, 300);
    }
  
    /* ── Helpers ─────────────────────────────────────────────── */
    function findById(id) {
      for (var i = 0; i < locations.length; i++) {
        if (locations[i].id === id) return locations[i];
      }
      return null;
    }
  
    function scrollListToTop() {
      var list = document.getElementById('icm-list');
      if (list) list.scrollTop = 0;
    }
  
    function esc(s) {
      return String(s || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
  
    function debounce(fn, ms) {
      var t;
      return function () { clearTimeout(t); t = setTimeout(fn, ms); };
    }
  
  })();